import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"background-color":"#fff","margin-bottom":"10px"},
  class: "card"
}
const _hoisted_2 = {
  style: {"background-color":"#fff"},
  class: "card-header border-0 py-5"
}
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "card-title fw-bolder text-black" }
const _hoisted_5 = {
  class: "text-black",
  style: {"color":"#b5b5c3","font-size":"12px"}
}
const _hoisted_6 = { class: "" }
const _hoisted_7 = {
  class: "card-title fw-bolder text-white",
  style: {"background-color":"#000","padding-top":"5px","padding-bottom":"5px","padding-right":"10px","padding-left":"10px","border-radius":"8px"}
}
const _hoisted_8 = { class: "card-body p-0" }
const _hoisted_9 = {
  style: {"background-color":"#fff"},
  class: "card-header border-0 py-5"
}
const _hoisted_10 = { class: "" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-black",
  style: {"color":"#b5b5c3","font-size":"12px"}
}, " jumlah ", -1)
const _hoisted_12 = { class: "card-title fw-bolder text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.chartTitle), 1),
        _createElementVNode("span", _hoisted_5, "Informasi mengenai " + _toDisplayString(_ctx.chartTitle), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.tahun), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_apexchart, {
        style: {"background-color":"#fff"},
        class: "mixed-widget-12-chart card-rounded-bottom",
        options: _ctx.chartOptions,
        series: _ctx.series,
        height: "300",
        type: "bar"
      }, null, 8, ["options", "series"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.jumlah), 1)
      ])
    ])
  ]))
}